import React from 'react';
import { Col, Row, Nav } from 'react-bootstrap';
import { BorderedBottomTabs, CustomNavLink, NavItem } from '@spark/ui-components/components/Tabs';
import AnexosCard from '../Tabs/Baixar/AnexosCard';
import AnexosUploadCard from '../Tabs/Enviar/AnexosUploadCard';

const TabsAnexos = ({
  activeTab,
  setActiveTab
}) => {
  const tabs = [
        {
      id: 'upload',
      label: 'Enviar anexos',
      component: AnexosUploadCard
    },
    {
      id: 'download',
      label: 'Baixar anexos',
      component: AnexosCard
    },
  ];

  const renderTabContent = () => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (!currentTab) return null;
    const TabComponent = currentTab.component;
    return <TabComponent />;
  };

  return <>
    <Row>
      <Col md={12}>
        <BorderedBottomTabs className="mb-3">
          <Nav variant="tabs" className="nav-tabs">
            {tabs.map((tab) => (
              <NavItem key={tab.id}>
                <CustomNavLink active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
                  <span className="tab-text">{tab.label}</span>
                </CustomNavLink>
              </NavItem>
            ))}
          </Nav>
        </BorderedBottomTabs>
      </Col>
    </Row>

    {renderTabContent()}
  </>;
};

export default TabsAnexos;
